const initialInsuranceTpa = {
    insuranceTpaPermissions:{},
    insuranceTpaLists: [],
    insuranceTpaStatus: [],
    changedInsuranceTpaStatus : [],
    loadingInsuranceTpa: false,
    errorsInsuranceTpa: {}
}

const  insuranceTpaReducer = (insuranceTpa = initialInsuranceTpa, action) => {
    switch (action.type) {
        case "GET_INSURANCE_TPA_LIST_PENDING":
        case "ADD_INSURANCE_TPA_PENDING":
        case "UPDATE_INSURANCE_TPA_PENDING":
        case "UPDATE_INSURANCE_TPA_STATUS_PENDING":
        case "DELETE_INSURANCE_TPA_PENDING":
        case "GET_INSURANCE_TPA_LIST_BY_ID_PENDING":
        case "SAVE_AUTHORITY_LETTER_TPA_PENDING":
        case "UPLOAD_COMPANY_AUTHORITY_LETTER_TPA_PENDING":
            return { ...insuranceTpa, loadingInsuranceTpa: true };

        case "GET_INSURANCE_TPA_LIST_FULFILLED":
            return {
                ...insuranceTpa,
                loadingInsuranceTpa: false,
                insuranceTpaLists: action.payload,
                insuranceTpaCount: action.count,
                insuranceTpaPermissions:action.permissions,
            };

        case "ADD_INSURANCE_TPA_FULFILLED":
            return {
                ...insuranceTpa,
                loadingInsuranceTpa: false,
                changedInsuranceTpaStatus: action.payload,
            };

        case "UPDATE_INSURANCE_TPA_FULFILLED":
            return {
                ...insuranceTpa,
                loadingInsuranceTpa: false,
                changedInsuranceTpaStatus: action.payload,
            };

        case "UPDATE_INSURANCE_TPA_STATUS_FULFILLED":
            return {
                ...insuranceTpa,
                loadingInsuranceTpa: false,
                changedInsuranceTpaStatus: action.payload,
            };

        case "GET_INSURANCE_TPA_LIST_BY_ID_FULFILLED":
            return {
                ...insuranceTpa,
                loadingInsuranceTpa: false,
                insuranceTpaLists: action.payload,
                staticData: action.staticData,
            };

        case "DELETE_INSURANCE_TPA_FULFILLED":
            return {
                ...insuranceTpa,
                loadingInsuranceTpa: false,
                changedInsuranceTpaStatus: action.payload
            };

        case "SAVE_AUTHORITY_LETTER_TPA_FULFILLED":
        case "UPLOAD_COMPANY_AUTHORITY_LETTER_TPA_FULFILLED":
            return {
                ...insuranceTpa,
                loadingInsuranceTpa: false,
                changedInsuranceTpaStatus: action.payload
            };

        case "RESET_DELETE_INSURANCE_TPA_STATUS":
            return {
                ...insuranceTpa,
                loadingInsuranceTpa: false,
                insuranceTpaStatus:{},
                changedInsuranceTpaStatus: [],
                errorsInsuranceTpa:{}
            };

        case "GET_INSURANCE_TPA_LIST_REJECTED":
        case "ADD_INSURANCE_TPA_REJECTED":
        case "UPDATE_INSURANCE_TPA_REJECTED":
        case "UPDATE_INSURANCE_TPA_STATUS_REJECTED":
        case "DELETE_INSURANCE_TPA_REJECTED":
        case "GET_INSURANCE_TPA_LIST_BY_ID_REJECTED":
        case "SAVE_AUTHORITY_LETTER_TPA_REJECTED":
        case "UPLOAD_COMPANY_AUTHORITY_LETTER_TPA_REJECTED":
            return {
                ...insuranceTpa,
                loadingInsuranceTpa: false,
                errorsInsuranceTpa: action.payload
            };
        default:
            return insuranceTpa;
    }
}

export default insuranceTpaReducer;